import React, { useEffect, useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

const useCreateUser = ({ id, fetchUsers, onHide, userData }) => {
  const { authData } = useSelector((state) => state.loginSlice);
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState({
    username: "",
    email: "",
    role: "",
  });
  const [submitLoader, setSubmitLoader] = useState(false);
  const [errors, setErrors] = useState(null);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (userData) {
      setUserDetails({
        username: userData.sName,
        email: userData.sEmail,
        role: userData.iRoleId,
      });
    } else {
      setUserDetails({
        username: "",
        email: "",
        role: "",
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    let { name, value, type } = e.target;

    setUserDetails((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const fetchRoles = async () => {
    try {
      let url = `${endpoint.GET_ROLES}`;

      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        dispatch,
      });

      if (response.data.success) {
        const roles = response.data.data.roles;
        setRoles(roles);
      }
    } catch (error) {
     
    }
  };

  useEffect(() => {

    fetchRoles();
  }, []);

  const validateForm = () => {
    let errors = {};

    if (!userDetails.username?.trim()) {
      errors.username = "Plan Name is required.";
    } else if (userDetails.username.length < 3) {
      errors.username = "Plan Name must be at least 3 characters.";
    }

    if (!userDetails.email?.trim()) {
      errors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userDetails.email)) {
      errors.email = "Please enter a valid email address.";
    }

    if (!userDetails.role) {
      errors.role = "Please select a Role.";
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    if (id) {
      updateUser();
    } else {
      createUser();
    }
    // }
  };

  const createUser = async () => {
    try {
      setSubmitLoader(true);
      const response = await apiHandler({
        url: endpoint.CREATE_USER,
        authToken: authData,
        dispatch,
        method: "POST",
        data: {
          name: userDetails.username,
          email: userDetails.email,
          roleId: userDetails.role,
        },
      });

      setUserDetails({ username: "", email: "", role: "" });
      onHide();
      setErrors({});
      if (response.data.success) {
        toast.success(response.data.message);
        fetchUsers();
      } else {
        toast.error(response.data.message);
        fetchUsers();
      }
    } catch (error) {
    
    } finally {
      setSubmitLoader(false);
    }
  };

  const updateUser = async () => {
    try {
      setSubmitLoader(true);
      const response = await apiHandler({
        url: `${endpoint.UPDATE_USER}/${id}`,
        authToken: authData,
        dispatch,
        method: "PUT",
        data: {
          name: userDetails.username,
          email: userDetails.email,
          roleId: userDetails.role,
        },
      });
      onHide();
      setErrors({});
      setUserDetails({ username: "", email: "", role: "" });
      if (response.data.success) {
        toast.success(response.data.message);
        fetchUsers();
      } else {
        toast.error(response.data.message);
        fetchUsers();
      }
    } catch (error) {
   
    } finally {
      setSubmitLoader(false);
    }
  };

  const renderErrorMessage = (fieldName) => {
    if (errors && errors[fieldName]) {
      return errors[fieldName];
    }
    return null;
  };

  const handleBlur = (e) => {
    const { name, value, type } = e.target;
    let mainErrors = { ...errors };

    if (type === "text") {
      if (!value.trim()) {
        mainErrors[name] = `${name} is required`;
      } else {
        delete mainErrors[name];
      }
    }
    if (type === "email") {
      if (!value?.trim()) {
        mainErrors[name] = "Email is required.";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        mainErrors[name] = "Please enter a valid email address.";
      } else {
        delete mainErrors[name];
      }
    }
    if (type === "select-one") {
      if (!value.trim()) {
        mainErrors[name] = `${name} is required`;
      } else {
        delete mainErrors[name];
      }
    }

    setErrors(mainErrors);
  };

  return {
    userDetails,
    submitLoader,
    errors,
    handleChange,
    setErrors,
    setUserDetails,
    handleBlur,
    renderErrorMessage,
    handleSubmit,
    roles,
  };
};

export default useCreateUser;
